// extracted by mini-css-extract-plugin
export default {"container":"literacy_container__5ls2F","newQuizzesContainer":"literacy_newQuizzesContainer__6QNPv","textDraw":"literacy_textDraw__LPA3H"};